import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../Dashboard";

export const emailVerificationSettingsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "email-verification",
}).lazy(() => import("./EmailVerificationSettings.lazy").then((d) => d.Route));
